var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28418 6.62914C5.30916 6.41392 5.27508 6.19663 5.18472 5.99496C5.09437 5.79328 4.95028 5.61291 4.76418 5.46851L0.92918 1.46914V0.869141H12.8415L22.0498 18.3441L30.1445 0.869141H41.5V1.46727L38.2175 4.18789C38.0801 4.28049 37.9739 4.40323 37.9099 4.54336C37.8459 4.6835 37.8264 4.83591 37.8535 4.98476V24.9835C37.826 25.1324 37.8452 25.2849 37.9093 25.4251C37.9733 25.5653 38.0798 25.688 38.2175 25.7804L41.422 28.501V29.0991H25.3107V28.501L28.6235 25.7129C28.9528 25.4316 28.9528 25.3473 28.9528 24.9179V8.75164L19.725 29.0335H18.4792L7.73685 8.75164V22.3435C7.64801 22.9154 7.86685 23.491 8.33268 23.9054L12.6487 28.4373V29.0354H0.411346V28.4373L4.72735 23.9054C4.95441 23.7006 5.12301 23.4527 5.21969 23.1816C5.31637 22.9104 5.33845 22.6234 5.28418 22.3435V6.62914Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumWhite);
export default __webpack_public_path__ + "static/media/medium-white.23e1ab8ce92a722b5ad5bbe1a9ae2176.svg";
export { ForwardRef as ReactComponent };